
import { defineComponent } from 'vue';
import { useMeta } from 'vue-meta';

export default defineComponent({
  name: 'App',
  setup() {
    const title = 'AC: Character Maker';

    useMeta({
      'mobile-web-app-capable': {
        title
      },
      'apple-mobile-web-app-title': {
        title
      },
      htmlAttrs: {
        lang: 'en'
      }
    });
  }
});
